
import { CentroCustoResume } from "../../types/comercial/centroCusto"
import { ApiError, ApiResponse } from "../../types/global/apiTypes"
import { axiosInstance } from "../axiosInstance"
import { handleAxiosResponse } from "../handleAxiosResponse"
import handleAxiosError from "../handleAxiosError"

export const getCentrosResume = async (): Promise<ApiResponse<CentroCustoResume[]>> => {
  try {
    const response = await axiosInstance().get<CentroCustoResume[] | ApiError>(`/comercial/centrocusto/resume`)
    return handleAxiosResponse<CentroCustoResume[]>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}